export default{

    company : state => {

        return state.company
    },

    styleHeader : state => {

        return state.headerStyle
    },

    styleLetter : state => {

        return state.letterStyle
    },

    enigmaToogleStyle : state => {

        return state.enigmaToogleStyle
    },

    mission : state => {

        return state.mission
    },
    getWsWithTagManager: state =>{
        return state.wsWithTagManager
    }
}